import { Component, Input, OnInit } from '@angular/core';
import {
    ConfirmationTimeRecordingModel,
    TimesheetEntryInterface,
    TimesheetEntryModel,
    TimesheetManualEntryModel,
    TimeUtilities,
    UiResponsiveService,
    ValueHelperModel,
    ValueHelperService,
} from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Component({
    selector: 'pace-time-sheet-entries',
    templateUrl: './time-sheet-entries.component.html',
    styleUrls: ['./time-sheet-entries.component.scss'],
})
export class TimeSheetEntriesComponent implements OnInit {
    @Input()
    public enableStandbyTravel = false;

    @Input()
    public otherTimeSheetEntries: TimesheetEntryInterface[] = [];

    @Input()
    public model: ConfirmationTimeRecordingModel;

    private taskTypes: ValueHelperModel[];
    public isMobile$: Observable<boolean>;
    public constructor(
        private readonly valueHelperService: ValueHelperService,
        private readonly uiResponsiveService: UiResponsiveService,
    ) {}
    public ngOnInit(): void {
        this.taskTypes = this.valueHelperService.getTimesheetGapTypeInfo();

        this.isMobile$ = this.uiResponsiveService.isMobile$;
    }

    public getDesc(entry: TimesheetEntryInterface): string {
        let taskType: ValueHelperModel | undefined;
        if ((<TimesheetEntryModel | TimesheetManualEntryModel>entry).notificationId.qmNum) {
            const workCode =
                this.enableStandbyTravel && entry instanceof TimesheetManualEntryModel
                    ? entry.taskTypeDropdown.selectedEntry?.value
                    : (<TimesheetEntryModel>entry).workCode.value;

            taskType = workCode ? this.taskTypes.find((item) => item.code === workCode) : undefined;
        } else {
            const workCode = (<TimesheetManualEntryModel>entry).taskTypeDropdown.selectedEntry?.value;
            taskType = workCode ? this.taskTypes.find((item) => item.code === workCode) : undefined;
        }
        return taskType ? taskType.descText : '';
    }

    public isOverlapping(entry: TimesheetEntryModel): boolean {
        return this.model.timeRecordingEntries.value.some((timeRecEntry) =>
            TimeUtilities.hasOverlap(
                entry.startTime.value,
                entry.endTime.value,
                timeRecEntry.startDateTime,
                timeRecEntry.endDateTime,
            ),
        );
    }
}
